import {collection, updateDoc, doc, increment, getDoc, setDoc} from "firebase/firestore";
import {fire} from "../../../fire";

export const incremetarMetrica = async ({col='metricas', idFunnel, propiedad, idUsuario}) =>{


    let id = idFunnel + idUsuario;

    let docuemento = doc(fire, col, id)
    try {
        await updateDoc(docuemento, {
            [propiedad]: increment(1),
        })

    }catch(err){

        let dox = await getDoc(docuemento);
        if (!dox.exists()){
            await setDoc(docuemento, {[propiedad]: 1, idFunnel: idFunnel, idUsuario: idUsuario});
        }
    }

}